import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'donations';

export function useGetAllDonations(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetDonation(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateDonation() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateDonation({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteDonation({id}) {
    return useDelete({queryKey: [endpoint, id]});
}


const frequencyNames = {
    'Monthly': 'months',
    'Quarterly': 'quarters',
    'Yearly': 'years',
};

type FrequencyKey = keyof typeof frequencyNames;

export function getFrequencyName(frequency:FrequencyKey)
{
    return frequencyNames[frequency] ?? 'N/A';
};
